var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"map-page"},[_c('NavDrawer'),_c('MapView',{ref:"mapView",style:(_vm.mapViewportStyle)}),_c('ToolContainer'),_c('DataContainer'),_c('MapControlsCustom'),_c('LayerLoadingNotice'),_c('ToastNotification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }